/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppService } from './app.service';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SitemapComponent } from './sitemap/sitemap.component';
import { DomainComponent } from './domain/domain.component';

import { IcemedxLibModule } from '../../projects/icemedx-lib/src/lib/icemedx-lib.module';

//Patient kiosk
import { MainComponent } from '../../projects/patientkiosk/src/app/main/main.component';
import { NameofpatientComponent } from '../../projects/patientkiosk/src/app/nameofpatient/nameofpatient.component';
import { FullprofileComponent } from '../../projects/patientkiosk/src/app/fullprofile/fullprofile.component';
import { ReasonforadmissionComponent } from '../../projects/patientkiosk/src/app/reasonforadmission/reasonforadmission.component';
import { PatientregistrationcompleteComponent } from '../../projects/patientkiosk/src/app/patientregistrationcomplete/patientregistrationcomplete.component';

// Patient portal
import { PatientdashboardComponent } from 'projects/patientportal/src/app/patientdashboard/patientdashboard.component';
import { PhrcontactComponent } from 'projects/patientportal/src/app/phrcontact/phrcontact.component';
import { PhrappointmentsComponent } from 'projects/patientportal/src/app/phrappointments/phrappointments.component';
import { PhrappointmentdetailsComponent } from 'projects/patientportal/src/app/phrappointmentdetails/phrappointmentdetails.component';
import { PhrclinicalsummariesComponent } from 'projects/patientportal/src/app/phrclinicalsummaries/phrclinicalsummaries.component';
import { PhrclinicalnotesComponent } from 'projects/patientportal/src/app/phrclinicalnotes/phrclinicalnotes.component';
import { PhrordersComponent } from 'projects/patientportal/src/app/phrorders/phrorders.component';
import { PhrdocumentsComponent } from 'projects/patientportal/src/app/phrdocuments/phrdocuments.component';
import { PhrmedicationsComponent } from 'projects/patientportal/src/app/phrmedications/phrmedications.component';
import { PhrproblemsComponent } from 'projects/patientportal/src/app/phrproblems/phrproblems.component';
import { PhrallergiesComponent } from 'projects/patientportal/src/app/phrallergies/phrallergies.component';
import { PhrsettingsComponent } from 'projects/patientportal/src/app/phrsettings/phrsettings.component';
import { SurveyComponent } from 'projects/patientportal/src/app/survey/survey.component';
import { PhrprovidersComponent } from 'projects/patientportal/src/app/phrproviders/phrproviders.component';

// Messages
import { MessageToolbarComponent } from '../../projects/messages/src/app/message-toolbar/message-toolbar.component';
import { MessagesComponent } from '../../projects/messages/src/app/messages/messages.component';
import { NewmessageComponent } from '../../projects/messages/src/app/newmessage/newmessage.component';
import { ForwardmessageComponent } from '../../projects/messages/src/app/newmessage/forwardmessage.component';
import { ReplymessageComponent } from '../../projects/messages/src/app/newmessage/replymessage.component';
import { ViewmessageComponent } from '../../projects/messages/src/app/viewmessage/viewmessage.component';

// Reports
import { ReportsComponent } from '../../projects/reports/src/app/reports/reports.component';
import { ReportComponent } from '../../projects/reports/src/app/report/report.component';
import { ViewreportComponent } from '../../projects/reports/src/app/viewreport/viewreport.component';
import { PrintreportComponent } from '../../projects/reports/src/app/viewreport/printreport.component';

// Domain Profile
import { ProviderComponent } from 'projects/domainprofile/src/app/provider/provider.component';
import { VendorComponent } from '../../projects/domainprofile/src/app/vendor/vendor.component';
import { PharmacyComponent } from 'projects/domainprofile/src/app/pharmacy/pharmacy.component';
import { PayerComponent } from 'projects/domainprofile/src/app/payer/payer.component';

// Components
import { IceNavComponent } from '../../projects/icemedx-lib/src/components/ice-nav/ice-nav.component';

// Services
import { LoginService } from '../../projects/icemedx-lib/src/login/login.service';
import { MessageService } from '../../projects/icemedx-lib/src/services/message/message.service';
import { ReportService } from '../../projects/icemedx-lib/src/services/report/report.service';
import { CustomFormService } from '../../projects/icemedx-lib/src/services/custom/customform.service';
import { IceNavService } from '../../projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { PatientKioskService } from '../../projects/icemedx-lib/src/services/patientkiosk/patientkiosk.service';

// 3rd Party
import fontawesome from '@fortawesome/fontawesome';
import solid from '@fortawesome/fontawesome-free-solid';
import { LandingComponent } from './landing/landing.component';
import { AccountingSummaryComponent } from '../../projects/accounting/src/app/accountingsummary/accountingsummary.component';
import { LedgerComponent } from '../../projects/accounting/src/app/ledger/ledger.component';
import { InventoryComponent } from '../../projects/accounting/src/app/inventory/inventory.component';
import { ItemComponent } from '../../projects/accounting/src/app/item/item.component';
import { ServiceitemChargeComponent } from '../../projects/accounting/src/app/serviceitemcharge/serviceitemcharge.component';
import { BillTemplateComponent } from '../../projects/accounting/src/app/billtemplate/billtemplate.component';
import { BillingTemplatesComponent } from '../../projects/accounting/src/app/billingtemplates/billingtemplates.component';
import { PyrdocumentsComponent } from '../../projects/payer/src/app/pyrdocuments/pyrdocuments.component';
import { SubscribersearchComponent } from '../../projects/search/src/app/subscribersearch/subscribersearch.component';
import { PatientsearchComponent } from '../../projects/search/src/app/patientsearch/patientsearch.component';
import { AddsubscriberComponent } from '../../projects/domainprofile/src/app/addsubscriber/addsubscriber.component';
import { MeetingsComponent } from '../../projects/schedule/src/app/meetings/meetings.component';
import { AddpatientComponent } from '../../projects/domainprofile/src/app/addpatient/addpatient.component';
import { PharmdocumentsComponent } from '../../projects/pharmacy/src/app/pharmdocuments/pharmdocuments.component';
import { BillingstatementComponent } from '../../projects/accounting/src/app/billingstatement/billingstatement.component';
import { ServicechargeHistoryComponent } from '../../projects/accounting/src/app/servicechargehistory/servicechargehistory.component';
import { OutstandingaccountbalanceComponent } from '../../projects/accounting/src/app/outstandingaccountbalance/outstandingaccountbalance.component';
import { ManagementguidelinesummaryComponent } from '../../projects/PHR/src/app/managementguidelinesummary/managementguidelinesummary.component';
import { ListOfMedicationsComponent } from '../../projects/PHR/src/app/listofmedications/listofmedications.component';
import { PaytohistoryComponent } from '../../projects/accounting/src/app/paytohistory/paytohistory.component';
import { PaymentpostingComponent } from '../../projects/accounting/src/app/paymentposting/paymentposting.component';
import { SingleservicechargeComponent } from '../../projects/accounting/src/app/singleservicecharge/singleservicecharge.component';
import { ListOfAppointmentsComponent } from '../../projects/EHR/src/app/listofappointments/listofappointments.component';
import { ListOfEncountersComponent } from '../../projects/EHR/src/app/listofencounters/listofencounters.component';
import { AccountingperiodComponent } from '../../projects/accounting/src/app/accountingperiod/accountingperiod.component';
import { ListOfDocumentsComponent } from '../../projects/EHR/src/app/listofdocuments/listofdocuments.component';
import { ListOfPaymentsComponent } from '../../projects/EHR/src/app/listofpayments/listofpayments.component';
import { ListofproblemsComponent } from '../../projects/EHR/src/app/listofproblems/listofproblems.component';
import { ClaimsbucketComponent } from '../../projects/accounting/src/app/claimsbucket/claimsbucket.component';
import { ClaimshistoryComponent } from '../../projects/accounting/src/app/claimshistory/claimshistory.component';
import { SingleservicehistoryComponent } from '../../projects/accounting/src/app/singleservicehistory/singleservicehistory.component';
import { ActivitystatusComponent } from '../../projects/PHR/src/app/activitystatus/activitystatus.component';
import { ClientsearchComponent } from '../../projects/PHR/src/app/clientsearch/clientsearch.component';


@NgModule({
    declarations: [
        AppComponent,
        DashboardComponent,
        SitemapComponent,
        DomainComponent,
        MessagesComponent,        
        NewmessageComponent,
        ForwardmessageComponent,
        ReplymessageComponent,
        ViewmessageComponent,
        MessageToolbarComponent,
        MainComponent,
        NameofpatientComponent,
        FullprofileComponent,
        ReasonforadmissionComponent,
        PatientregistrationcompleteComponent,

        PatientdashboardComponent,
        PhrcontactComponent,
        PhrappointmentsComponent,
        PhrappointmentdetailsComponent,
        PhrclinicalsummariesComponent,
        PhrclinicalnotesComponent,
        PhrordersComponent,
        PhrdocumentsComponent,
        PhrmedicationsComponent,
        PhrproblemsComponent,
        PhrallergiesComponent,
        PhrsettingsComponent,
        SurveyComponent,
        PhrprovidersComponent,

        ReportsComponent,
        ReportComponent,
        ViewreportComponent,
        PrintreportComponent,
        LandingComponent,

        ProviderComponent,
        VendorComponent,
        PharmacyComponent,
        PayerComponent,
        AccountingSummaryComponent,
        LedgerComponent,
        InventoryComponent,
        ItemComponent,
        ServiceitemChargeComponent,
        SingleservicechargeComponent,
        SingleservicehistoryComponent,
        AccountingperiodComponent,
        BillTemplateComponent,
        BillingTemplatesComponent,
        PyrdocumentsComponent,
        SubscribersearchComponent,
        PatientsearchComponent,
        AddsubscriberComponent,
        AddpatientComponent,
        MeetingsComponent,
        PharmdocumentsComponent,
        ServicechargeHistoryComponent,
        PaytohistoryComponent,
        PaymentpostingComponent,
        BillingstatementComponent,
        OutstandingaccountbalanceComponent,
        ManagementguidelinesummaryComponent,
        ListOfMedicationsComponent,
        ListOfAppointmentsComponent,
        ListOfEncountersComponent,
        ListOfDocumentsComponent,
        ListOfPaymentsComponent,
        ListofproblemsComponent,
        ClaimshistoryComponent,
        ClaimsbucketComponent,
        ActivitystatusComponent,
        ClientsearchComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CommonModule,
        HttpClientModule,
        FormsModule,
        IcemedxLibModule
    ],
    providers: [
        LoginService,
        IceNavService,
        MessageService,
        ReportService,
        CustomFormService,
        AppService,
        PatientKioskService
    ],
    bootstrap: [AppComponent, IceNavComponent]
})
export class AppModule {
    constructor() {
        fontawesome.library.add(solid.faUser);
    }
}
